import * as React from 'react'
import { IDataListItemProps } from './DataListItem'

export interface IDataListProps {
  children:
    | React.ReactElement<IDataListItemProps>
    | Array<React.ReactElement<IDataListItemProps>>
  className?: string
  columnCount?: string | number
  columnSize?: string | number
}

export class DataList extends React.PureComponent<IDataListProps> {
  public render() {
    const dataListStyle: React.CSSProperties = {
      columns: `${this.props.columnSize || '300px'} ${this.props.columnCount ||
        'auto'}`,
    }

    return (
      <div className={this.props.className} style={dataListStyle}>
        {this.props.children}
      </div>
    )
  }
}
